import { CivilCaseExt } from '.';

export class CaseQueryMessageResponse {
  errorCode: string;
  errorText: string;
  civilCaseExt: CivilCaseExt;
}
